import React from "react"
import { Article } from "../../Model/Article"
import { getUserLang } from "../../Utils/utiltyHelper"
import { Link } from "react-router-dom"
import { Trans } from "react-i18next"
import { contentLangConverter } from "../../Utils/Converter"

const BigArticleCard = ({ article }: { article: Article }) => {
  return (
    <div>
      <Link to={"/" + getUserLang() + "/blog/" + article.urlTitle}>
        <a className="rounded-lg overflow-hidden border border-gray-100 gap-4 md:grid md:grid-cols-2 cursor-pointer">
          <section>
            <img
              style={{ width: "450px", height: "300px" }}
              className="object-cover"
              src={article.featureImage}
            />
          </section>

          <section className="mt-2 p-4 md:p-0">
            <div>
              <p className="text-primary uppercase text-sm font-bold md:mt-0 mt-4">
                <span className="rounded-full w-20 h-8 bg-blue-50 px-4 py-1 text-sm normal-case font-medium text-blue-500 mr-4">
                  <Trans>Blog.new-blog</Trans>
                </span>
                <Trans>Blog.update</Trans>
              </p>
            </div>
            <h2 className="md:text-3xl text-2xl font-bold leading-tight mt-4 mb-2">
              {article.title}
            </h2>
            <div>
              <p className="text-sm text-gray-500 leading-loose text-ellipsis overflow-hidden max-h-20">
                {contentLangConverter(article.language, article.content)}...
              </p>
            </div>
            <div className="mt-2">
              <span className="uppercase text-xs font-bold text-gray-400 border-r-2 pr-2 border-r-gray-400">
                {article.authorName}
              </span>
              <span className="uppercase text-xs font-bold text-gray-400 pl-2">
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/*@ts-ignore*/}
                {new Date(article.publishDate.seconds * 1000).toDateString()}
              </span>
            </div>
          </section>
        </a>
      </Link>
    </div>
  )
}

export default BigArticleCard
